import { ExportColumn } from "./export-column.model";
import { ExportType } from "./export-type.model";

export class ExportParameters  {
    public type:ExportType;
    public columns:ExportColumn[];

    constructor(type, columns) {
        this.type = type;
        this.columns = columns;
    }
}